export const getPcPgKey = (pc: string | number, pg: string | number): string => {
  if (!pc || !pg)
    return 'UNKNOWN'
  return `${pc.toString()}${pg.toString()}`
}
